module.exports = __webpack_public_path__ + "img/connection.5b6390d1.svg";